"use client";
import {useRef, useState} from "react";
import {AiOutlineClose} from "react-icons/ai";
import {FiUpload} from "react-icons/fi";

export function NeoFileUpload({
  onChange,
  defaultImage
}: {
  onChange: (file: File | null) => void;
  defaultImage?: any;
}) {
  const [previewUrl, setPreviewUrl] = useState<string | null>(
    defaultImage || null
  );
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setPreviewUrl(URL.createObjectURL(file));
      onChange?.(file);
    }
  };

  const triggerFileSelect = () => {
    fileInputRef.current?.click();
  };

  const handleRemove = () => {
    setPreviewUrl(null);
    fileInputRef.current!.value = ""; // reset file input
    onChange?.(null);
  };

  return (
    <div className="relative h-32 w-32">
      {/* Image Preview */}
      <div className="flex h-full w-full items-center justify-center overflow-hidden rounded-xl border border-gray-300 bg-gray-100">
        {previewUrl ? (
          <img
            src={previewUrl}
            alt="Profile preview"
            className="h-full w-full object-cover"
          />
        ) : (
          <img
            src="/images/avatar.png"
            alt="Profile preview"
            className="h-full w-full object-cover"
          />
        )}
      </div>

      {/* Upload Icon Overlay */}
      <button
        type="button"
        onClick={triggerFileSelect}
        className="absolute -bottom-2 -right-2 rounded-full border border-gray-300 bg-white p-2 shadow-md hover:bg-gray-100"
        title="Upload"
      >
        <FiUpload className="h-5 w-5 text-gray-700" />
      </button>

      {previewUrl && (
        <button
          type="button"
          onClick={handleRemove}
          className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full border border-gray-300 bg-white shadow hover:bg-red-100"
          title="Remove"
        >
          <span className="text-xs font-bold text-red-500">
            <AiOutlineClose size={15} />
          </span>
        </button>
      )}

      {/* Hidden Input */}
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleImageChange}
        className="hidden"
      />
    </div>
  );
}
